import { Button, Flex } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { ListPaginationControl } from 'src/components/ListPaginationControl';

import { GetParamsObject } from '@/model/query-params';
import { useFiltersForm } from '@/utils/useFiltersForm';
import { usePaginationState } from 'src/components/ListPaginationControl/utils/usePaginationState';
import { PageContent } from 'src/components/PageContent';
import { SectionBox } from 'src/components/SectionBox';
import { useAccessControlPermissionTypes } from '../../services/queries/access-control';
import { accessControlPermissionTypesBreadcrumb } from './breadcrumb';
import { AccessControlPermissionTypesFiltersBox } from './components/AccessControlPermissionTypesFiltersBox';
import { AccessControlPermissionTypesTable } from './components/AccessControlPermissionTypesTable';
import { AccessControlPermissionTypesFilters } from './types';
import CenteredSpinner from '@/components/CenterSpinner/CenteredSpinner';
import { PermissionType } from '@/model';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';
import { useTranslation } from 'react-i18next';

const sortOrder = 'desc';
const sortField = 'created_at';

export const AccessControlPermissionTypes = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { getListPaginationControlProps, pageSize, pageNumber } = usePaginationState();
  const filtersForm = useFiltersForm<AccessControlPermissionTypesFilters>({
    defaultValues: {
      name: '',
    },
  });
  const filterData = filtersForm.watch();

  const params = GetParamsObject(filterData, pageNumber, pageSize, sortOrder, sortField);

  const { data: permissionTypesData, isLoading } = useAccessControlPermissionTypes(params);

  // POR ALGUM MOTIVO ESSE MOCK NÃO TÁ FUNCIONANDO CERTO, ELE NÃO RETORNA O OBJETO NO FORMATO { data: [], meta: {} }
  // RETORNA O ARRAY DIRETO. PRA NÃO PERDER TEMPO FIZ ESSE WORKAROUND PRA VERIFICAR SE O SUBSCRIPTION É ARRAY (PQ NO MOCK, ELE É ARRAY)
  const permissionTypes = Array.isArray(permissionTypesData)
    ? (permissionTypesData as unknown as PermissionType[])
    : permissionTypesData?.data || [];

  const permissionTypesTotal = permissionTypesData?.meta?.pages || 0;

  return (
    <PageContent
      title={t('pages.access_control_permission_types.title')}
      actionsContent={
        <Button
          display='flex'
          alignItems='center'
          gap={2}
          onClick={() => navigate('/access-control/permission-types/new')}
          width={{ base: '100%', md: 'initial' }}
        >
          <ChakraFeatherIcon name='plus-circle' />
          {t('pages.access_control_permission_types.button_new_permission_type')}
        </Button>
      }
      breadcrumbItems={accessControlPermissionTypesBreadcrumb}
    >
      <SectionBox bodyProps={{ gap: 'small' }} mt={8}>
        <AccessControlPermissionTypesFiltersBox filtersForm={filtersForm} />

        <Flex direction='column' gap='deka'>
          <Flex direction='column' gap='micro'>
            <AccessControlPermissionTypesTable isLoading={isLoading} permissionTypes={permissionTypes} />
            <ListPaginationControl totalPages={permissionTypesTotal} {...getListPaginationControlProps()} />
          </Flex>
        </Flex>
      </SectionBox>

      <CenteredSpinner isLoading={false} />
    </PageContent>
  );
};
